import { Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TransitDuplicateRow } from '../TransitDuplicateRow';
import { TransitViewStakeholdersFormValues } from './validateTransitViewStakeholdersForm';

interface AdditionalSupplyChainActorProps {
  form: UseFormReturnType<TransitViewStakeholdersFormValues>;
  editDisabled: boolean;
}

export const AdditionalSupplyChainActor: React.FC<AdditionalSupplyChainActorProps> = ({ form, editDisabled }) => (
  <Stack mb="xl">
    <Title order={5} fw={600}>
      Additional supply chain actor
    </Title>
    <TransitDuplicateRow
      addButtonLabel="Add"
      addButtonDataPW="add-additional-supply-chain-actor-btn"
      form={form}
      inputs={[
        {
          type: 'MultiLang',
          label: 'Role',
          name: 'role',
          width: 24,
          code: 'CL704',
        },
        {
          type: 'Input',
          width: 24,
          name: 'identificationNumber',
          label: 'Identification number',
        },
      ]}
      arrayPath="Consignment.AdditionalSupplyChainActor"
      disabled={editDisabled}
    />
  </Stack>
);
